import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsGoogletagmanagerComponent } from './simple-icons-googletagmanager.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsGoogletagmanagerComponent ],
    exports:      [ SimpleIconsGoogletagmanagerComponent ],
    bootstrap:    []
})
export class SimpleIconsGoogletagmanagerModule {}
